import React, { useEffect, useState } from "react";
import { TextField, Grid, useTheme, Typography, Modal, CircularProgress, useMediaQuery } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {  RTL } from "../../../../components";
import AlertInfo from "components/AlertInfo";
import { axios } from "./../../../../axios";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "redux/Action";
import { makeStyles } from "@material-ui/styles";
import theme from "theme";


const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: "100%",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: "100%",
  },
  imageInput: {
    display: "none",
  },
  divider:{
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    backgroundColor: "#273c75",
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
    width:'100%',
    height:'100%'
  },
  buttonProgress: {
    color: '#121E3E',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
  },
}));


const InfoCompany = (props) => {
  const { open, onClose, title, id,onAccept, company, ...rest } = props;
  const [data, setData] = useState({});
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  const dispatch = useDispatch();
  const classes = useStyles();

  const token = useSelector((state) => state.token);
  const isLoading = useSelector((state) => state.isLoading);
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const GET_Data = async () => {
    try{
      const res = await axios.get(`companies/${id}`, {
        headers: headers,
      });
     // console.log(res.data.data)
     setData(res.data.data)
     dispatch(Loading());
    }catch(e)
    {
      dispatch(Loading());      
    }
}

  useEffect(() => {
    if(id!=null)
    {
      GET_Data();
      dispatch(Loading());
    }
  


  }, []);

  // const theme = useTheme();
  return (



    <Modal
    open={open}
    style={{Height:'100vh',width:'80%',marginRight:'10%',marginLeft:'10%', display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', }}      
    
    onClose={onClose}
  >
    <div style={{backgroundColor:'white',padding:'2%',width:'100%',  border: "none",
}}>

{!isLoading?
<>
{data ? (
             Object.keys(data).length>0?
              (
      <Grid>
          <Grid container justify="space-between" xs={12} sm={11}>
            <Grid  item xs={12} sm={6}>
              <Typography style={{wordBreak:'break-all'}} display="inline" variant="h5" gutterBottom>
                نام شغل:
              </Typography>
              <Typography
                style={{ marginRight: 5 ,wordBreak:'break-all'}}
                variant="body2"
                display="inline"
                gutterBottom
              >
                {data?.company?.name}
              </Typography>
            </Grid> 

            <Grid style={isSmall?{marginTop:10}:{}} item xs={12} sm={5}>
            <Typography style={{wordBreak:'break-all'}} display="inline" variant="h5" gutterBottom>
                شماره تماس:
              </Typography>
              <Typography
                style={{ marginRight: 5,wordBreak:'break-all' }}
                variant="body2"
                display="inline"
                gutterBottom
              >
                {data?.company?.tell}

              </Typography>
            </Grid>
          </Grid>

         
          <Grid
            style={!isSmall?{ marginTop: 20 }:{marginTop:10}}
            container
            justify="space-between"
            xs={12}
            sm={11}
          >
          <Grid item xs={12} sm={6}>
          <Typography style={{wordBreak:'break-all'}} display="inline" variant="h5" gutterBottom>
              شهر :
            </Typography>
            <Typography
              style={{ marginRight: 5 ,wordBreak:'break-all'}}
              variant="body2"
              display="inline"
              gutterBottom
            >
                {data?.company?.city?.name + " - "+data?.company?.city?.get_province?.name }

            </Typography>
          </Grid>
          <Grid style={isSmall?{marginTop:10}:{}} item xs={12} sm={5}>
          <Typography  style={{wordBreak:'break-all'}} display="inline" variant="h5" gutterBottom>
                شماره ثبت     :
              </Typography>
              <Typography
                style={{ marginRight: 5 ,wordBreak:'break-all'}}
                variant="body2"
                display="inline"
                gutterBottom
              >
                {data?.company?.reg_number}

              </Typography>
            </Grid>

          </Grid>
          <Grid 
            style={!isSmall?{ marginTop: 20 }:{marginTop:10}}
            xs={12} sm={11}>
          <Typography style={{wordBreak:'break-all'}} display="inline" variant="h5" gutterBottom>
              آدرس :
            </Typography>
            <Typography
              style={{ marginRight: 5,wordBreak:'break-all' }}
              variant="body2"
              display="inline"
              gutterBottom
            >
                {data?.company?.address}
 
            </Typography>
          </Grid>
          
        </Grid>
) : (
  <div
    style={{
      display: "flex",
      flex: 1,
      alignItems: "center",
      padding: 50,

      height: "100%",
      justifyContent: "center",
    }}
  >
    <Typography>متاسفانه هیچ رکوردی یافت نشد</Typography>
  </div>
)
) : (
""
)}
</>
:
<div     style={{Height:'100vh',width:'80%',marginRight:'10%',marginLeft:'10%', display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', }}    >

{isLoading && <CircularProgress size={24}  />}
</div>

}
  </div>
  </Modal>

  );
};

export default InfoCompany;
